import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import React__default__default from 'react';
import PropTypes__default from 'prop-types';
import styles from '../../../node_modules/@flixbus/honeycomb/dist/scss/components/progress-tracker.scss.js';
import HoneyBem from '../../../packages/honey-bem/honey-bem.js';
import SROnly from '../../_atoms/sr-only/sr-only.js';
import { progressTrackerItemCompletedValidation } from './progress-tracker-item-validator.js';

var bem = HoneyBem.init('progress-tracker', styles);
var linkClassName = bem.e('link');
var textClassName = bem.e('text');
var ProgressTrackerItem = function (_a) {
  var extraClasses = _a.extraClasses,
    children = _a.children,
    current = _a.current,
    completed = _a.completed,
    completedSrText = _a.completedSrText,
    href = _a.href,
    RouterLink = _a.RouterLink,
    rest = __rest(_a, ["extraClasses", "children", "current", "completed", "completedSrText", "href", "RouterLink"]);
  var textContent = /*#__PURE__*/React__default__default.createElement(React__default__default.Fragment, null, /*#__PURE__*/React__default__default.createElement("span", {
    className: textClassName
  }, children), completed && completedSrText && /*#__PURE__*/React__default__default.createElement(SROnly, null, ' ', completedSrText));
  var buildLink = RouterLink ? /*#__PURE__*/React__default__default.createElement(RouterLink, __assign({
    className: linkClassName,
    to: href || rest.to || ''
  }, rest), textContent) : /*#__PURE__*/React__default__default.createElement("a", __assign({
    href: href,
    className: linkClassName
  }, rest), textContent);
  return /*#__PURE__*/React__default__default.createElement("li", __assign({
    className: bem.e('item', {
      completed: completed
    }, extraClasses)
  }, current && {
    'aria-current': 'step'
  }), href || rest.to ? buildLink : /*#__PURE__*/React__default__default.createElement("span", __assign({
    className: linkClassName
  }, rest), textContent));
};
ProgressTrackerItem.displayName = 'ProgressTrackerItem';
ProgressTrackerItem.defaultProps = {
  extraClasses: null,
  current: false,
  completed: false,
  completedSrText: null,
  href: null,
  RouterLink: null
};
ProgressTrackerItem.propTypes = {
  extraClasses: PropTypes__default.string,
  children: PropTypes__default.node.isRequired,
  current: PropTypes__default.bool,
  completed: PropTypes__default.bool,
  completedSrText: progressTrackerItemCompletedValidation(),
  href: PropTypes__default.string,
  RouterLink: PropTypes__default.oneOfType([PropTypes__default.func, PropTypes__default.object])
};

export { ProgressTrackerItem, ProgressTrackerItem as default };
